"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("./Button"));
var Link_1 = require("./Link");
var spacing_1 = require("./spacing");
var react_copy_to_clipboard_1 = require("react-copy-to-clipboard");
var CopyButton = function (_a) {
    var text = _a.text, label = _a.label, buttonProps = _a.buttonProps, linkProps = _a.linkProps, onCopy = _a.onCopy, _b = _a.variant, variant = _b === void 0 ? 'link' : _b, divProps = __rest(_a, ["text", "label", "buttonProps", "linkProps", "onCopy", "variant"]);
    return (react_1.default.createElement(react_copy_to_clipboard_1.CopyToClipboard, __assign({}, { onCopy: onCopy, text: text }),
        react_1.default.createElement(spacing_1.Div, __assign({}, divProps),
            variant === 'button' && (react_1.default.createElement(Button_1.default, __assign({}, buttonProps), label || 'Copy')),
            variant === 'link' && react_1.default.createElement(Link_1.Link, __assign({}, linkProps), label || 'Copy'))));
};
exports.default = CopyButton;
//# sourceMappingURL=CopyButton.js.map